import React from "react";
import { Link } from "react-router-dom";
import { Radio } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function Footer() {
  const { user } = useAuth();
  return (
    <footer className="border-t border-white/5 mt-20 bg-black/40" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 py-10 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2">
            <Radio className="w-5 h-5 text-emerald-500" />
            <span className="fl-display text-lg font-extrabold tracking-tighter flex items-baseline gap-1.5">FLIBOE<span className="text-emerald-500">FM</span></span>
          </div>
          <p className="text-xs text-slate-500 mt-2 leading-relaxed">
            The internet radio platform for independent broadcasters. Launch your station — name it yours, brand it yours. Worldwide listeners in perfect sync.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-6 text-xs">
          <div>
            <div className="fl-mono text-[10px] tracking-[0.25em] uppercase text-slate-500 mb-2">Product</div>
            <div className="space-y-1.5 text-slate-300">
              <div><Link to="/" className="hover:text-emerald-500">Discover</Link></div>
              <div><Link to="/dashboard" className="hover:text-emerald-500">Studio</Link></div>
              {user?.role === "admin" && (
                <div><Link to="/admin" className="text-emerald-500 hover:text-emerald-400" data-testid="footer-admin-link">Admin</Link></div>
              )}
              <div><Link to="/pricing" className="hover:text-emerald-500">Plans</Link></div>
              <div><Link to="/advertise" className="hover:text-emerald-500" data-testid="footer-advertise-link">Advertise</Link></div>
              <div><Link to="/produce" className="hover:text-emerald-500" data-testid="footer-produce-link">AI shows</Link></div>
              <div><Link to="/free-sample" className="hover:text-emerald-500" data-testid="footer-free-sample-link">Free sample</Link></div>
              <div><Link to="/blog" className="hover:text-emerald-500" data-testid="footer-blog-link">Blog</Link></div>
              <div><Link to="/pulse" className="hover:text-emerald-500" data-testid="footer-pulse-link">Pulse · SEO blogs</Link></div>
              <div><Link to="/promo" className="hover:text-emerald-500" data-testid="footer-promo-link">Share kit</Link></div>
              <div><Link to="/brochure" className="hover:text-emerald-500" data-testid="footer-brochure-link">Brochure</Link></div>
              <div><Link to="/terms" className="hover:text-emerald-500" data-testid="footer-terms-link">Terms</Link></div>
              <div><Link to="/privacy" className="hover:text-emerald-500" data-testid="footer-privacy-link">Privacy</Link></div>
              <div><Link to="/about" className="hover:text-emerald-500" data-testid="footer-about-link">About</Link></div>
              <div><Link to="/contact" className="hover:text-emerald-500" data-testid="footer-contact-link">Contact</Link></div>
            </div>
          </div>
          <div>
            <div className="fl-mono text-[10px] tracking-[0.25em] uppercase text-slate-500 mb-2">Account</div>
            <div className="space-y-1.5 text-slate-300">
              <div><Link to="/login" className="hover:text-emerald-500">Sign in</Link></div>
              <div><Link to="/signup" className="hover:text-emerald-500">Create account</Link></div>
              <div><Link to="/forgot-password" className="hover:text-emerald-500">Forgot password</Link></div>
            </div>
          </div>
        </div>
        <div>
          <div className="fl-mono text-[10px] tracking-[0.25em] uppercase text-slate-500 mb-2">Support</div>
          <p className="text-xs text-slate-300 leading-relaxed">
            <strong className="text-slate-300">Have a question?</strong> Click the chat button at the bottom-right of every page — our AI Support agent is on it 24/7 and handles every inquiry from sign-in trouble to billing to station setup.
          </p>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 py-5 flex flex-wrap items-center justify-between gap-3 text-xs text-slate-500">
          <div data-testid="footer-copyright">© 2026 Fliboe FM · Broadcast worldwide, no transmitter required.</div>
          <div className="fl-mono tracking-widest uppercase">/ ON AIR · WORLDWIDE</div>
        </div>
      </div>
    </footer>
  );
}
